import { frontendURL } from 'dashboard/helper/URLHelper.js';
import { SUPER_ADMIN_PERMISSION } from 'dashboard/constants/permissions';

import AiReviewsLayout from './AiReviewsLayout.vue';
import BatchesPage from './pages/BatchesPage.vue';
import NewBatchPage from './pages/NewBatchPage.vue';
import BatchDetailPage from './pages/BatchDetailPage.vue';
import ReviewDetailPage from './pages/ReviewDetailPage.vue';
import ReviewPoliciesPage from './pages/ReviewPoliciesPage.vue';
import ReviewPolicyDetailPage from './pages/ReviewPolicyDetailPage.vue';
import KnowledgeBasesPage from './pages/KnowledgeBasesPage.vue';
import ModelProfilesPage from './pages/ModelProfilesPage.vue';

const meta = {
  permissions: [SUPER_ADMIN_PERMISSION],
};

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/ai-reviews'),
      component: AiReviewsLayout,
      children: [
        {
          path: '',
          redirect: to => ({
            name: 'ai_review_batches',
            params: to.params,
          }),
        },
        {
          path: 'batches',
          name: 'ai_review_batches',
          meta,
          component: BatchesPage,
        },
        {
          path: 'batches/new',
          name: 'ai_review_batch_new',
          meta,
          component: NewBatchPage,
        },
        {
          path: 'batches/:batchId',
          name: 'ai_review_batch_show',
          meta,
          component: BatchDetailPage,
        },
        {
          path: 'batches/:batchId/reviews/:reviewId',
          name: 'ai_review_show',
          meta,
          component: ReviewDetailPage,
        },
        {
          path: 'policies',
          name: 'ai_review_policies',
          meta,
          component: ReviewPoliciesPage,
        },
        {
          path: 'policies/:policyId',
          name: 'ai_review_policy_show',
          meta,
          component: ReviewPolicyDetailPage,
        },
        {
          path: 'knowledge-bases',
          name: 'ai_review_knowledge_bases',
          meta,
          component: KnowledgeBasesPage,
        },
        {
          path: 'model-profiles',
          name: 'ai_review_model_profiles',
          meta,
          component: ModelProfilesPage,
        },
      ],
    },
  ],
};
